module.exports = __webpack_public_path__ + "img/zhinan.21123f45.png";